import { createAction, props } from "@ngrx/store";
import { GetEnumRequest } from "../enumeration/enumeration.model";
import { Labels } from "src/app/app.models";
import { BankForm, GetBankAccountsResponse, GetBankGFFPFieldsResponse, GetBankGFFPParams, NewBankAccount } from "src/app/feature/digital-payment/bank-account/bank-account.models";

export enum DigitalPaymentActions {
  getBankAccounts = '[Digital Payments] getBankAccounts',
  getBankAccountsSuccess = '[Digital Payments] getBankAccountsSuccess',
  getBankGFFPFields = '[Digital Payments] getBankGFFPFields',
  getBankGFFPFieldsSuccess = '[Digital Payments] getBankGFFPFieldsSuccess',
  addNewBankAccount = '[Digital Payments] addNewBankAccount',
  dpGetEnums = '[Digital Payment] dpGetEnums',
  dpGetEnumsSuccess = '[Digital Payment] dpGetEnumsSuccess',
  dpSendValidate = '[Digital Payment] dpSendValidate',
  dpSendValidateSuccess = '[Digital Payment] dpSendValidateSuccess',
  saveNewBankAccount = '[Digital Payment] saveNewBankAccount',
  getPaymentPlatformMetaData = '[Digital Payment] getPaymentPlatformMetaData',
  getPaymentPlatformMetaDataSuccess = '[Digital Payment] getPaymentPlatformMetaDataSuccess',
  dpSendCommit = '[Digital Payment] dpSendCommit',
  dpSendCommitSuccess = '[Digital Payment] dpSendCommitSuccess'
}

export const GetBankAccounts = createAction(
  DigitalPaymentActions.getBankAccounts,
  props<{ digitalProfileId: string, firebaseAuthToken: string }>()
)

export const GetBankAccountsSuccess = createAction(
  DigitalPaymentActions.getBankAccountsSuccess,
  props<GetBankAccountsResponse>()
)

export const GetBankGFFPFields = createAction(
  DigitalPaymentActions.getBankGFFPFields,
  props<GetBankGFFPParams>()
)

export const GetBankGFFPFieldsSuccess = createAction(
  DigitalPaymentActions.getBankGFFPFieldsSuccess,
  props<GetBankGFFPFieldsResponse>()
)

export const AddNewBankAccount = createAction(
  DigitalPaymentActions.addNewBankAccount,
  props<NewBankAccount>()
)

export const DpGetEnums = createAction(
  DigitalPaymentActions.dpGetEnums,
  props<{ getEnumRequest: GetEnumRequest, endpoint: string, sendValidatePayload: any, transactionId: string, operation: string, isNewBankAccount: boolean, fbAuthToken: string, cmsLabels: Labels }>()
)

export const DpGetEnumsSuccess = createAction(
  DigitalPaymentActions.dpGetEnumsSuccess,
  props<{ getEnumsResponse: any, sendValidatePayload: any, transactionId: string, endpoint: string, operation: string, isNewBankAccount: boolean, fbAuthToken: string }>() // Todo: Tim: fix type
)

export const DpSendValidate = createAction(
  DigitalPaymentActions.dpSendValidate,
  props<{ sendValidatePayload: any, transactionId: string, endpoint: string, operation: string, isNewBankAccount: boolean, fbAuthToken: string }>() // Todo: Tim: fix type
)

export const DpSendValidateSuccess = createAction(
  DigitalPaymentActions.dpSendValidateSuccess,
  props<{ sendValidateResponse: any }>() // Todo: Tim: fix type
)

export const SaveNewBankAccount = createAction(
  DigitalPaymentActions.saveNewBankAccount,
  props<{ sendValidateResponse: any, sendValidatePayload: any, fbAuthToken: string }>() // Todo: Tim: fix type
)

export const GetPaymentPlatformMetaData = createAction(
  DigitalPaymentActions.getPaymentPlatformMetaData,
  props<any>() // Todo: Tim: fix type
)

export const GetPaymentPlatformMetaDataSuccess = createAction(
  DigitalPaymentActions.getPaymentPlatformMetaDataSuccess,
  props<{ getPaymentPlatformMetaDataResponse: any }>()
)

export const DpSendCommit = createAction(
  DigitalPaymentActions.dpSendCommit,
  props<{ transactionId: string | number, locale: string, endpoint: string }>()
)

export const DpSendCommitSuccess = createAction(
  DigitalPaymentActions.dpSendCommitSuccess,
  props<{sendCommitResponse: any}>() // Todo: Tim: fix types
)